var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExportXlsx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 2C5.5 1.4475 5.903 1 6.4 1H18.1C18.597 1 19 1.4475 19 2V18C19 18.5525 18.597 19 18.1 19H6.4C5.903 19 5.5 18.5525 5.5 18V15H1.9C1.403 15 1 14.5525 1 14V6C1 5.4475 1.403 5 1.9 5H5.5V2ZM12 5V2H6.5V5H12ZM13 2V5H18V2H13ZM12 6H10V9.5H12V6ZM13 9.5V6H18V9.5H13ZM12 10.5H10V14H12V10.5ZM13 14V10.5H18V14H13ZM12 15H6.5V18H12V15ZM13 18V15H18V18H13ZM9 6V14H1.9V6H9ZM3.613 7.5H4.6865L5.558 9.377L6.4785 7.5H7.4815L6.1 10L7.5135 12.5H6.455L5.5055 10.535L4.5605 12.5H3.4865L4.9235 9.991L3.613 7.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportXlsx);
export default __webpack_public_path__ + "static/media/Export-XLSX.a2c841d384f09e95b1312246f6cde198.svg";
export { ForwardRef as ReactComponent };